function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#4D4D4D",
  fillRule: "evenodd",
  d: "M2 .667c.736 0 1.333.594 1.333 1.34v22.66h22.66c.697 0 1.27.524 1.334 1.204l.006.129c0 .736-.594 1.333-1.34 1.333H2c-.434 0-.82-.206-1.063-.529A1.322 1.322 0 0 1 .667 26V2.007c0-.697.524-1.27 1.204-1.334L2 .667zM23.333 2a2.667 2.667 0 1 1 0 5.333l-.02-.001-6.93 10.803a2.667 2.667 0 1 1-5.02.792l-3.033-2.453a2.667 2.667 0 1 1 1.644-2.1l3.06 2.473c.299-.116.625-.18.966-.18l.157.005 6.856-10.69A2.667 2.667 0 0 1 23.333 2z"
});

var SvgChartBenefit = function SvgChartBenefit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChartBenefit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chart-benefit.bbecca5d.svg";
export { ForwardRef as ReactComponent };